import { Layout } from 'antd';
import SidebarContent from './SidebarContent';

const { Sider } = Layout;

const Sidebar = () => {

  return (
    <Sider
      width={280}
      className='sidebar'
    >
      <SidebarContent onClose={() => { }} />
    </Sider>
  );
};

export default Sidebar;
